import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldViewRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-view',
	path: '/secure/admin/ViewFieldsScreen.jspa',
};
